import type { MouseEvent } from "react";
import { useAppContext } from "../contexts/AppContext";
import SearchBox from "./sodoSearch/SearchBox";
import SearchResultBox from "./sodoSearch/SearchResultBox";
import CompassInsight from "./compassInsight";
import { css } from "@emotion/react";
import useWindowDimensions from "./sodoSearch/hooks/useWindowDimensions";

export default function Search() {
  const { dispatch } = useAppContext();

  const handleBackdropClick = (e: MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.target === e.currentTarget) {
      dispatch("update", { showPopup: false });
    }
  };

  const { width } = useWindowDimensions();

  const showCompassInsight =
    (window.compassUrl || import.meta.env.VITE_COMPASS_URL) &&
    (window.frjToken || import.meta.env.VITE_FRJ_TOKEN) &&
    (window.algoliaApiKey || import.meta.env.VITE_ALGOLIA_API_KEY) &&
    (window.algoliaAppIdKey || import.meta.env.VITE_ALGOLIA_APP_ID) &&
    (window.algoliaIndexName || import.meta.env.VITE_ALGOLIA_INDEX_NAME) &&
    width > 1300;

  return (
    <div
      className="h-screen w-screen pt-20 antialiased z-50 relative ghost-display"
      onClick={handleBackdropClick}
      css={css`
        max-width: 100dvw;
        display: flex !important;
        justify-content: center;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-evenly;
          max-width: 1200px;
        `}
      >
        <div
          className="bg-white w-full max-w-[95vw] sm:max-w-lg rounded-lg shadow-xl relative translate-z-0 animate-popup"
          css={css`
            align-self: flex-start;
          `}
        >
          <SearchBox />
          <SearchResultBox />
        </div>
        {showCompassInsight && <CompassInsight />}
      </div>
    </div>
  );
}
